import { Box, Stack, Text } from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import type { FC } from 'react';

import * as styles from '../PreviousApplications.css';

interface TimelineItemProps {
  icon: JSX.Element;
  date: JSX.Element;
  content: JSX.Element;
  isLast?: boolean;
}

export const TimelineItem: FC<TimelineItemProps> = ({
  icon,
  date,
  content,
  isLast = false,
}) => (
  <Box className={styles.timelineGrid}>
    <>
      <Box className={styles.leftColumn}>{icon}</Box>
      <Box className={styles.rightColumn}>
        <Text size="xsmall" tone="secondary">
          {date}
        </Text>
      </Box>
    </>

    <>
      {!isLast ? (
        <Box className={[styles.leftColumn, styles.verticalLine]} />
      ) : null}
      <Box className={styles.rightColumn}>
        <Stack space="xsmall">{content}</Stack>
        {!isLast ? <Box style={{ height: vars.space.small }} /> : null}
      </Box>
    </>
  </Box>
);
